import { FC, forwardRef } from 'react'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { Button, Text } from 'react-native-paper'
import { SvgProps } from 'react-native-svg'
import { FontsEnum } from '../../../constants/fonts'

interface AppBarButtonProps {
    children: string
    backgroundColor?: string
    textColor?: string
    fontSize?: number
    onPress: () => void
    contentStyle?: StyleProp<ViewStyle>
    style?: StyleProp<ViewStyle>
    Icon?: FC<SvgProps>
}

export default forwardRef<View, AppBarButtonProps>(function BarButton(
    {
        children,
        backgroundColor,
        textColor = '#FFFFFF',
        onPress,
        fontSize = 16,
        contentStyle,
        style,
        Icon,
    },
    ref
) {
    return (
        <View collapsable={false} ref={ref} style={[styles.container, { backgroundColor }]}>
            <Button
                textColor={textColor}
                onPress={onPress}
                icon={Icon}
                style={[styles.button, style]}
                contentStyle={[styles.buttonContent, contentStyle]}
            >
                <Text style={[styles.text, { color: textColor, fontSize }]}>{children}</Text>
            </Button>
        </View>
    )
})

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
    },
    button: {
        flexDirection: 'row',
    },
    buttonContent: {
        height: '100%',
    },
    text: {
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
    },
})
